import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="bg-white shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <a href="/test1" className="block">
            <img 
              src="/images/smart_impact_logo.jpg" 
              alt="Smart Impact" 
              className="h-12" 
            />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;